import { Component } from '@angular/core';
import { Contrato } from 'src/app/base/domain/contrato.model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ContratoService } from 'src/app/base/services/contrato.service';
import { ReturnAPI, Page } from 'src/app/base/domain/return-api.model';
import { ContratoListFilterOptions } from 'src/app/global/lists/contrato-list/contrato-list.component';
import { Cliente } from 'src/app/base/domain/cliente.model';
import { ContaCliente } from 'src/app/base/domain/conta-cliente.model';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ClienteService } from 'src/app/base/services/cliente.service';
import { DialogService } from 'src/app/global/services/dialog.service';

@Component({
  selector: 'app-clientes-inativos-detail',
  templateUrl: './clientes-inativos-detail.component.html',
  styleUrls: ['./clientes-inativos-detail.component.css'],
})
export class ClientesInativosDetailComponent {
  clienteId: number;
  cliente: Cliente;
  title = 'Contratos do Cliente';

  contratos: Contrato[] = [];
  ultimoContrato: Contrato;

  contas: ContaCliente[] = [];
  contaCorrente: ContaCliente;
  tipoContas: string[] = [];

  queryOptions = new QueryOptions({ pageSize: 10 });
  totalRecords = 0;
  loading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private clienteService: ClienteService,
    private contratoService: ContratoService,
    private dialogService: DialogService,
  ) {
    this.route.params.subscribe((params: Params) => {
      this.clienteId = params.id;
    });
  }

  ngOnInit(): void {
    this.queryOptions.params = {
      idCliente: this.clienteId || null,
    };
    this.consultarDetalhesCliente();
  }

  private consultarDetalhesCliente(): void {
    this.clienteService.findOne(this.clienteId).subscribe((response: ReturnAPI<Cliente>) => {
      if (response.success) {
        this.cliente = response.object;
        this.contas = this.cliente.contas;
        this.listarContas();
        this.listarContratos();
      }
    });
  }

  listarContratos(pageNumber: number = 0): void {
    this.queryOptions.pageNumber = pageNumber + 1;
    this.loading = true;
    this.contratoService.findAll(this.queryOptions).subscribe((response: ReturnAPI<Page<Contrato>>) => {
      if (response.success) {
        this.totalRecords = response.object.totalElements;
        this.contratos = response.object.content;
        if (this.contratos.length > 0) {
          this.ultimoContrato = this.contratos.sort((a, b) => (a.id < b.id ? 1 : -1))[0];
        }
      } else {
        this.contratos = [];
        this.dialogService.feedbackReturnAPI(response, '');
      }
      this.loading = false;
    });
  }

  listarContas(): void {
    this.contas?.forEach((conta: ContaCliente) => {
      if (conta.tipo === 'CORRENTE') {
        this.contaCorrente = conta;
        this.tipoContas.push('Conta Corrente');
      }
    });
  }

  onClienteUpdated(_: Cliente): void {
    this.consultarDetalhesCliente();
    this.listarContratos();
  }

  onContratosPage(page: number): void {
    this.listarContratos(page);
  }

  onDisclosure(contrato: Contrato): void {
    this.router.navigate(['base/contratos/acompanhamento-contrato-detail/' + contrato.id]);
  }

  onFilter(options: ContratoListFilterOptions): void {
    this.queryOptions.params = {
      nomeCliente: options.nomeCliente,
      situacaoContrato: options.situacoesContrato?.length ? `in:${options.situacoesContrato.join(',')}` : null,
      postoId: options.postoSelecionado ? options.postoSelecionado.id : null,
      repassePendente: options.repassePendente || null,
    };
    this.listarContratos();
  }
}
